// Single source of truth per le pagine pillar /servizi/<slug>.
// Ordine dell'array == ordine visualizzato in footer e nella griglia
// "Approfondisci ogni servizio" su /servizi.
//
// Aggiungere un servizio richiede:
//   1. Creare un file in shared/services-detail/<slug>.ts
//   2. Importarlo qui sotto e aggiungerlo a SERVICES_DETAIL nell'ordine voluto
// Tutto il resto (route SSR, sitemap, prerender, JSON-LD, breadcrumb) si
// aggiorna in automatico dal registro.

import type { ServiceDetail } from "./types";
import { CONSULENZA_AZIENDALE } from "./consulenza-aziendale";
import { MARKETING_DIGITALE } from "./marketing-digitale";
import { SVILUPPO_WEB_CRM } from "./sviluppo-web-crm";
import { SEO_SEM } from "./seo-sem";
import { INTELLIGENZA_ARTIFICIALE } from "./intelligenza-artificiale";
import { INTERNAZIONALIZZAZIONE } from "./internazionalizzazione";

export type {
  ServiceDetail,
  ServiceCategoryId,
  ServiceHero,
  ServiceDeliverable,
  ServiceProcessStep,
  ServiceFaq,
  ServiceSeo,
} from "./types";

export const SERVICES_DETAIL: readonly ServiceDetail[] = [
  CONSULENZA_AZIENDALE,
  MARKETING_DIGITALE,
  SVILUPPO_WEB_CRM,
  SEO_SEM,
  INTELLIGENZA_ARTIFICIALE,
  INTERNAZIONALIZZAZIONE,
] as const;

export const SERVICE_DETAIL_SLUGS: readonly string[] = SERVICES_DETAIL.map(
  (s) => s.slug,
);

export function getServiceDetailBySlug(
  slug: string,
): ServiceDetail | undefined {
  // Lookup case-insensitive: il client riceve `useParams().slug` raw e l'URL
  // potrebbe essere in maiuscolo (es. da link esterno o errore di copia).
  // Normalizziamo qui così client + server convergono sullo stesso record e
  // il canonical (sempre slug lowercase del registro) deduplica l'indice.
  const target = slug.toLowerCase();
  return SERVICES_DETAIL.find((s) => s.slug === target);
}
